// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// const ContactUs = () => {
//     const [formData, setFormData] = useState({ name: '', email: '', service: 'Residential', message: '' });
//     const [focusedInput, setFocusedInput] = useState(null);

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         alert(`Thank you ${formData.name}! Your interior design inquiry has been sent.`);
//         setFormData({ name: '', email: '', service: 'Residential', message: '' });
//     };

//     // Premium Pastel Studio Design Tokens
//     const theme = {
//         background: '#F8F6F2',    // Soft Alabaster White
//         cardBg: 'rgba(255, 255, 255, 0.8)', // Pure White Glass Base
//         accent: '#D4AF37',        // Champagne Gold Accent
//         textMain: '#2C302E',      // Charcoal Slate
//         textMuted: '#7A827E',     // Soft Muted Sage Grey
//         border: 'rgba(44, 48, 46, 0.08)' // Clean Subtle Boundary Lines
//     };

//     const animations = `
//     @keyframes slideRightFade {
//       from { opacity: 0; transform: translateX(-40px); }
//       to { opacity: 1; transform: translateX(0); }
//     }
//     @keyframes slideLeftFade {
//       from { opacity: 0; transform: translateX(40px); }
//       to { opacity: 1; transform: translateX(0); }
//     }
//     .animate-left-panel { animation: slideRightFade 1s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
//     .animate-right-panel { animation: slideLeftFade 1s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
//   `;

//     return (
//         <div style={{
//             background: theme.background,
//             minHeight: '100vh',
//             color: theme.textMain,
//             padding: '40px 60px',
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             boxSizing: 'border-box',
//             transition: 'background 0.5s ease'
//         }}>
//             <style>{animations}</style>

//             {/* Back Button Anchor */}
//             {/* <Link to="/" style={{ color: theme.textMuted, textDecoration: 'none', fontSize: '0.9rem', display: 'inline-block', marginBottom: '30px', transition: 'color 0.2s' }} onMouseEnter={(e) => e.target.style.color = theme.accent} onMouseLeave={(e) => e.target.style.color = theme.textMuted}>
//                 ← Return to Studio
//             </Link> */}

//             {/* Main Structural Twin Columns */}
//             <div style={{ display: 'flex', flexWrap: 'wrap', gap: '50px', marginTop: '10px' }}>

//                 {/* ==================== LEFT COLUMN: INQUIRY FORM ==================== */}
//                 <div className="animate-left-panel" style={{ flex: '1.2', minWidth: '320px' }}>
//                     <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '3px', fontSize: '0.85rem', fontWeight: '600' }}>Inquire Structure</span>
//                     <h1 style={{ fontSize: '2.8rem', fontWeight: '300', margin: '10px 0 30px 0', letterSpacing: '1px', color: theme.textMain }}>Let's Shape Your Space</h1>

//                     <form onSubmit={handleSubmit} style={{
//                         background: theme.cardBg,
//                         padding: '40px',
//                         borderRadius: '16px',
//                         border: `1px solid ${theme.border}`,
//                         backdropFilter: 'blur(10px)',
//                         boxShadow: '0 15px 35px rgba(44, 48, 46, 0.04)'
//                     }}>
//                         {/* Input Wrap Block */}
//                         {['name', 'email'].map((field) => (
//                             <div key={field} style={{ marginBottom: '25px', position: 'relative' }}>
//                                 <label style={{ display: 'block', fontSize: '0.85rem', color: theme.textMuted, textTransform: 'uppercase', marginBottom: '8px', letterSpacing: '1px' }}>
//                                     Your {field}
//                                 </label>
//                                 <input
//                                     type={field === 'email' ? 'email' : 'text'}
//                                     required
//                                     value={formData[field]}
//                                     onChange={(e) => setFormData({ ...formData, [field]: e.target.value })}
//                                     onFocus={() => setFocusedInput(field)}
//                                     onBlur={() => setFocusedInput(null)}
//                                     style={{
//                                         width: '100%',
//                                         background: 'rgba(44, 48, 46, 0.03)',
//                                         border: 'none',
//                                         borderBottom: `2px solid ${focusedInput === field ? theme.accent : theme.border}`,
//                                         padding: '12px 5px',
//                                         color: theme.textMain,
//                                         fontSize: '1rem',
//                                         outline: 'none',
//                                         transition: 'all 0.3s ease',
//                                         boxSizing: 'border-box'
//                                     }}
//                                 />
//                             </div>
//                         ))}

//                         {/* Select Dropdown Wrap */}
//                         <div style={{ marginBottom: '25px' }}>
//                             <label style={{ display: 'block', fontSize: '0.85rem', color: theme.textMuted, textTransform: 'uppercase', marginBottom: '8px', letterSpacing: '1px' }}>Project Dynamic</label>
//                             <select
//                                 value={formData.service}
//                                 onChange={(e) => setFormData({ ...formData, service: e.target.value })}
//                                 style={{
//                                     width: '100%',
//                                     background: theme.background,
//                                     border: `1px solid ${theme.border}`,
//                                     padding: '12px',
//                                     color: theme.textMain,
//                                     borderRadius: '6px',
//                                     fontSize: '1rem',
//                                     outline: 'none',
//                                     cursor: 'pointer'
//                                 }}
//                             >
//                                 <option value="Residential">Luxury Residential Architecture</option>
//                                 <option value="Commercial">Commercial Workspace Layout</option>
//                                 <option value="Kitchen">Bespoke Modular Kitchen</option>
//                                 <option value="Consultation">1-on-1 Design Consultation</option>
//                             </select>
//                         </div>

//                         {/* Textarea Block */}
//                         <div style={{ marginBottom: '30px' }}>
//                             <label style={{ display: 'block', fontSize: '0.85rem', color: theme.textMuted, textTransform: 'uppercase', marginBottom: '8px', letterSpacing: '1px' }}>Project Narrative</label>
//                             <textarea
//                                 rows="4"
//                                 required
//                                 placeholder="Tell us about your structural dimensions or design style expectations..."
//                                 value={formData.message}
//                                 onChange={(e) => setFormData({ ...formData, message: e.target.value })}
//                                 onFocus={() => setFocusedInput('message')}
//                                 onBlur={() => setFocusedInput(null)}
//                                 style={{
//                                     width: '100%',
//                                     background: 'rgba(44, 48, 46, 0.03)',
//                                     border: 'none',
//                                     borderBottom: `2px solid ${focusedInput === 'message' ? theme.accent : theme.border}`,
//                                     padding: '12px 5px',
//                                     color: theme.textMain,
//                                     fontSize: '1rem',
//                                     outline: 'none',
//                                     resize: 'none',
//                                     transition: 'all 0.3s ease',
//                                     boxSizing: 'border-box',
//                                     fontFamily: 'inherit'
//                                 }}
//                             />
//                         </div>

//                         {/* Premium Interactive Button Layout */}
//                         <button type="submit" style={{
//                             width: '100%',
//                             padding: '15px',
//                             background: theme.textMain,
//                             color: '#FFFFFF',
//                             border: 'none',
//                             borderRadius: '8px',
//                             fontWeight: '700',
//                             fontSize: '1rem',
//                             textTransform: 'uppercase',
//                             letterSpacing: '1px',
//                             cursor: 'pointer',
//                             boxShadow: '0 4px 15px rgba(44, 48, 46, 0.1)',
//                             transition: 'transform 0.2s ease, opacity 0.2s'
//                         }} onMouseEnter={(e) => e.target.style.transform = 'scale(1.02)'} onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}>
//                             Transmit Blueprint Request
//                         </button>
//                     </form>
//                 </div>

//                 {/* ==================== RIGHT COLUMN: DETAILS & SOCIALS ==================== */}
//                 <div className="animate-right-panel" style={{ flex: '1', minWidth: '300px', display: 'flex', flexDirection: 'column', gap: '30px', justifyContent: 'center' }}>

//                     {/* Glassmorphism Information Node Card */}
//                     <div style={{
//                         background: theme.cardBg,
//                         padding: '35px',
//                         borderRadius: '16px',
//                         border: `1px solid ${theme.border}`,
//                         boxShadow: '0 15px 30px rgba(44, 48, 46, 0.03)'
//                     }}>
//                         <h3 style={{ fontSize: '1.3rem', fontWeight: '400', color: theme.accent, marginBottom: '25px', letterSpacing: '1px' }}>Studio Touchpoints</h3>

//                         <div style={{ marginBottom: '20px' }}>
//                             <p style={{ margin: '0', fontSize: '0.8rem', color: theme.textMuted, textTransform: 'uppercase' }}>Direct Line</p>
//                             <p style={{ margin: '5px 0 0 0', fontSize: '1.1rem', fontWeight: '500', color: theme.textMain }}>+91 93590009527</p>
//                         </div>

//                         <div style={{ marginBottom: '20px' }}>
//                             <p style={{ margin: '0', fontSize: '0.8rem', color: theme.textMuted, textTransform: 'uppercase' }}>Electronic Mail</p>
//                             <p style={{ margin: '5px 0 0 0', fontSize: '1.1rem', fontWeight: '500', color: theme.textMain }}>stinteriorstudio.30@gmail.com</p>
//                         </div>

//                         <div>
//                             <p style={{ margin: '0', fontSize: '0.8rem', color: theme.textMuted, textTransform: 'uppercase' }}>Headquarters Studio</p>
//                             <p style={{ margin: '5px 0 0 0', fontSize: '1.05rem', fontWeight: '400', lineHeight: '1.5', color: theme.textMain }}>
//                                 Main Baner-Sus Road, Complex Block B,<br />Sus, Pune, Maharashtra 411021, India
//                             </p>
//                         </div>
//                     </div>

//                     {/* Social Architecture Navigation Block */}
//                     <div style={{
//                         background: theme.cardBg,
//                         padding: '25px 35px',
//                         borderRadius: '16px',
//                         border: `1px solid ${theme.border}`
//                     }}>
//                         <h4 style={{ margin: '0 0 15px 0', fontSize: '0.85rem', color: theme.textMuted, textTransform: 'uppercase', letterSpacing: '1px' }}>Digital Ecosystems</h4>
//                         <div style={{ display: 'flex', gap: '20px' }}>
//                             {['Instagram', 'Pinterest', 'LinkedIn', 'Behance'].map((platform) => (
//                                 <a key={platform} href={`https://${platform.toLowerCase()}.com`} target="_blank" rel="noreferrer" style={{
//                                     color: theme.textMain,
//                                     textDecoration: 'none',
//                                     fontSize: '0.95rem',
//                                     fontWeight: '500',
//                                     transition: 'color 0.2s ease'
//                                 }} onMouseEnter={(e) => e.target.style.color = theme.accent} onMouseLeave={(e) => e.target.style.color = theme.textMain}>
//                                     {platform}
//                                 </a>
//                             ))}
//                         </div>
//                     </div>

//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ContactUs;

import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ContactUs = () => {
    const [formData, setFormData] = useState({ name: '', email: '', service: 'Residential', message: '' });
    const [focusedInput, setFocusedInput] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        alert(`Thank you ${formData.name}! Your interior design inquiry has been sent.`);
        setFormData({ name: '', email: '', service: 'Residential', message: '' });
    };

    // Premium Pastel Studio Design Tokens
    const theme = {
        background: '#F8F6F2',    // Soft Alabaster White
        cardBg: 'rgba(255, 255, 255, 0.8)', // Pure White Glass Base
        accent: '#D4AF37',        // Champagne Gold Accent
        textMain: '#2C302E',      // Charcoal Slate
        textMuted: '#7A827E',     // Soft Muted Sage Grey
        border: 'rgba(44, 48, 46, 0.08)' // Clean Subtle Boundary Lines
    };

    // Advanced Layout Responsive CSS Injections
    const animations = `
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400&family=Montserrat:wght@300;400;500;600;700&display=swap');

    @keyframes slideRightFade {
      from { opacity: 0; transform: translateX(-40px); }
      to { opacity: 1; transform: translateX(0); }
    }
    @keyframes slideLeftFade {
      from { opacity: 0; transform: translateX(40px); }
      to { opacity: 1; transform: translateX(0); }
    }
    .animate-left-panel { animation: slideRightFade 1s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
    .animate-right-panel { animation: slideLeftFade 1s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

    /* Link Hover Transitions */
    .contact-link {
        color: ${theme.textMain};
        text-decoration: none;
        transition: color 0.3s ease;
    }
    .contact-link:hover {
        color: ${theme.accent} !important;
    }

    /* ==================== SCREEN RESPONSIVE LAYOUT BREAKPOINTS ==================== */
    @media (max-width: 768px) {
        .contact-screen-container { padding: 30px 20px !important; }
        .contact-main-split { gap: 40px !important; margin-top: 20px !important; }
        .contact-main-title { font-size: 2.2rem !important; margin: 10px 0 20px 0 !important; }
        .contact-form-card { padding: 25px 20px !important; border-radius: 12px !important; }
        .contact-panel-wrapper { min-width: 100% !important; }
        .contact-social-row { flex-wrap: wrap !important; gap: 15px 25px !important; }
    }

    @keyframes revealUp {
        from { opacity: 0; transform: translateY(40px); }
        to { opacity: 1; transform: translateY(0); }
    }

    .team-animate-entry { 
        animation: revealUp 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards; 
    }
  `;
    const inlineStyles = {
       
        pillBtn: {
            padding: '14px 40px',
            fontSize: '1rem',
            fontWeight: '600',
            color: '#FFFFFF',
            backgroundColor: '#2C302E',
            border: 'none',
            borderRadius: '30px',
            cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
            transition: 'all 0.2s ease',
            outline: 'none',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            display: 'inline-block',
            fontFamily: "'Cinzel', Georgia, serif",
        }
    };

    return (
        <div className="contact-screen-container" style={{
            background: theme.background,
            minHeight: '100vh',
            color: theme.textMain,
            padding: '60px 60px',
            fontFamily: "'Montserrat', sans-serif",
            boxSizing: 'border-box',
            transition: 'background 0.5s ease'
        }}>
            <style>{animations}</style>

            {/* ==================== CENTERED HEADING SECTION ==================== */}
            <section className="team-animate-entry" style={{
                textAlign: 'center',
                marginBottom: '60px',
                padding: '0 20px'
            }}>
                <span style={{
                    fontFamily: 'system-ui, -apple-system, sans-serif',
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '4px',
                    color: theme.accent,
                    display: 'block',
                    marginBottom: '12px'
                }}>
                    Inquire Structure
                </span>
                <h1 className="feedback-main-title" style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontSize: 'calc(0.3rem + 1.8vw)',
                    fontWeight: '400',
                    textTransform: 'uppercase',
                    letterSpacing: '6px',
                    color: theme.textMain,
                    margin: 0
                }}>
                    Let's Shape Your Space
                </h1>
                <div style={{
                    width: '60px',
                    height: '1px',
                    background: theme.accent,
                    margin: '24px auto 0 auto'
                }} />
            </section>

            {/* Main Structural Twin Columns */}
            <div className="contact-main-split" style={{ display: 'flex', flexWrap: 'wrap', gap: '50px', marginTop: '10px' }}>

                {/* ==================== LEFT COLUMN: INQUIRY FORM ==================== */}
                <div className="animate-left-panel contact-panel-wrapper" style={{ flex: '1.2', minWidth: '320px' }}>
                    <form onSubmit={handleSubmit} className="contact-form-card" style={{
                        background: theme.cardBg,
                        padding: '40px',
                        borderRadius: '16px',
                        border: `1px solid ${theme.border}`,
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 15px 35px rgba(44, 48, 46, 0.04)'
                    }}>
                        {/* Input Wrap Block */}
                        {['name', 'email'].map((field) => (
                            <div key={field} style={{ marginBottom: '25px', position: 'relative' }}>
                                <label style={{ display: 'block', fontSize: '0.85rem', color: theme.textMuted, textTransform: 'uppercase', marginBottom: '8px', letterSpacing: '1px' }}>
                                    Your {field}
                                </label>
                                <input
                                    type={field === 'email' ? 'email' : 'text'}
                                    required
                                    value={formData[field]}
                                    onChange={(e) => setFormData({ ...formData, [field]: e.target.value })}
                                    onFocus={() => setFocusedInput(field)}
                                    onBlur={() => setFocusedInput(null)}
                                    style={{
                                        width: '100%',
                                        background: 'rgba(44, 48, 46, 0.03)',
                                        border: 'none',
                                        borderBottom: `2px solid ${focusedInput === field ? theme.accent : theme.border}`,
                                        padding: '12px 5px',
                                        color: theme.textMain,
                                        fontSize: '1rem',
                                        outline: 'none',
                                        transition: 'all 0.3s ease',
                                        boxSizing: 'border-box',
                                        fontFamily: "'Montserrat', sans-serif"
                                    }}
                                />
                            </div>
                        ))}

                        {/* Select Dropdown Wrap */}
                        <div style={{ marginBottom: '25px' }}>
                            <label style={{ display: 'block', fontSize: '0.85rem', color: theme.textMuted, textTransform: 'uppercase', marginBottom: '8px', letterSpacing: '1px' }}>Project Dynamic</label>
                            <select
                                value={formData.service}
                                onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                                style={{
                                    width: '100%',
                                    background: theme.background,
                                    border: `1px solid ${theme.border}`,
                                    padding: '12px',
                                    color: theme.textMain,
                                    borderRadius: '6px',
                                    fontSize: '1rem',
                                    outline: 'none',
                                    cursor: 'pointer',
                                    fontFamily: "'Montserrat', sans-serif"
                                }}
                            >
                                <option value="Residential">Luxury Residential Architecture</option>
                                <option value="Commercial">Commercial Workspace Layout</option>
                                <option value="Kitchen">Bespoke Modular Kitchen</option>
                                <option value="Consultation">1-on-1 Design Consultation</option>
                            </select>
                        </div>

                        {/* Textarea Block */}
                        <div style={{ marginBottom: '30px' }}>
                            <label style={{ display: 'block', fontSize: '0.85rem', color: theme.textMuted, textTransform: 'uppercase', marginBottom: '8px', letterSpacing: '1px' }}>Project Narrative</label>
                            <textarea
                                rows="4"
                                required
                                placeholder="Tell us about your structural dimensions or design style expectations..."
                                value={formData.message}
                                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                                onFocus={() => setFocusedInput('message')}
                                onBlur={() => setFocusedInput(null)}
                                style={{
                                    width: '100%',
                                    background: 'rgba(44, 48, 46, 0.03)',
                                    border: 'none',
                                    borderBottom: `2px solid ${focusedInput === 'message' ? theme.accent : theme.border}`,
                                    padding: '12px 5px',
                                    color: theme.textMain,
                                    fontSize: '1rem',
                                    outline: 'none',
                                    resize: 'none',
                                    transition: 'all 0.3s ease',
                                    boxSizing: 'border-box',
                                    fontFamily: "'Montserrat', sans-serif"
                                }}
                            />
                        </div>

                        {/* Premium Interactive Button Layout */}
                        {/* <button type="submit" style={{
                            width: '100%',
                            padding: '15px',
                            background: theme.textMain,
                            color: '#FFFFFF',
                            border: 'none',
                            borderRadius: '8px',
                            fontWeight: '700',
                            fontSize: '1rem',
                            textTransform: 'uppercase',
                            letterSpacing: '1px',
                            cursor: 'pointer',
                            boxShadow: '0 4px 15px rgba(44, 48, 46, 0.1)',
                            transition: 'transform 0.2s ease, opacity 0.2s',
                            fontFamily: "'Montserrat', sans-serif"
                        }} onMouseEnter={(e) => e.target.style.transform = 'scale(1.02)'} onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}>
                            Create with Us
                        </button> */}
                        <button
                            type="submit"
                            style={{
                                ...inlineStyles.pillBtn,
                                backgroundColor: '#FFFFFF',
                                color: '#2C302E',
                                border: '1px solid rgba(44, 48, 46, 0.15)', // Subtle charcoal border
                                padding: '12px 28px',
                                borderRadius: '30px',
                                fontSize: '0.9rem',
                                fontWeight: '500',
                                letterSpacing: '1.5px',
                                textTransform: 'uppercase',
                                cursor: 'pointer',
                                transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                                outline: 'none'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.03)';
                                e.currentTarget.style.backgroundColor = '#D4AF37'; // Your signature gold accent
                                e.currentTarget.style.color = '#FFFFFF';
                                e.currentTarget.style.borderColor = '#D4AF37';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.backgroundColor = '#FFFFFF'; // Returns back to clean white
                                e.currentTarget.style.color = '#2C302E';
                                e.currentTarget.style.borderColor = 'rgba(44, 48, 46, 0.15)';
                            }}
                        >
                            Create with Us
                        </button>
                    </form>
                </div>

                {/* ==================== RIGHT COLUMN: DETAILS & SOCIALS ==================== */}
                <div className="animate-right-panel contact-panel-wrapper" style={{ flex: '1', minWidth: '300px', display: 'flex', flexDirection: 'column', gap: '30px', justifyContent: 'center' }}>

                    {/* Glassmorphism Information Node Card */}
                    <div style={{
                        background: theme.cardBg,
                        padding: '35px',
                        borderRadius: '16px',
                        border: `1px solid ${theme.border}`,
                        boxShadow: '0 15px 30px rgba(44, 48, 46, 0.03)'
                    }}>
                        <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.6rem', fontWeight: '500', color: theme.accent, marginBottom: '25px', letterSpacing: '1px' }}>Studio Touchpoints</h3>

                        {/* Linkable Phone details */}
                        <div style={{ marginBottom: '20px' }}>
                            <p style={{ margin: '0', fontSize: '0.8rem', color: theme.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Direct Line</p>
                            <p style={{ margin: '5px 0 0 0', fontSize: '1.1rem', fontWeight: '500' }}>
                                <a href="tel:+919359009527" className="contact-link">
                                    +91 93590 09527
                                </a>
                            </p>
                        </div>

                        {/* Linkable Email details */}
                        <div style={{ marginBottom: '20px' }}>
                            <p style={{ margin: '0', fontSize: '0.8rem', color: theme.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Electronic Mail</p>
                            <p style={{ margin: '5px 0 0 0', fontSize: '1.1rem', fontWeight: '500' }}>
                                <a href="mailto:hello@stinteriorstudio.com" className="contact-link">
                                    hello@stinteriorstudio.com
                                </a>
                            </p>
                        </div>

                        {/* Linkable Address details */}
                        <div>
                            <p style={{ margin: '0', fontSize: '0.8rem', color: theme.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Headquarters Studio</p>
                            <p style={{ margin: '5px 0 0 0', fontSize: '1.05rem', fontWeight: '400', lineHeight: '1.5' }}>
                                <a
                                    href="https://maps.app.goo.gl/9ni2MYn5biG2sUiC8"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact-link"
                                    style={{ display: 'block',fontWeight: '500' }}
                                >
                                   
                                   403 Platinum 9, Pashan-Sus Road, <br /> Behind Audi Showroom, Baner, Pune, MH-411045, INDIA
                                </a>
                            </p>
                        </div>
                    </div>

                    <div style={{
                        background: theme.cardBg,
                        padding: '25px 35px',
                        borderRadius: '16px',
                        border: `1px solid ${theme.border}`
                    }}>
                        <h4 style={{ margin: '0 0 15px 0', fontSize: '0.85rem', color: theme.textMuted, textTransform: 'uppercase', letterSpacing: '1px' }}>Digital Ecosystems</h4>
                        <div className="contact-social-row" style={{ display: 'flex', gap: '20px' }}>
                            {[
                                { name: 'Instagram', url: 'https://www.instagram.com/stinterior_studio?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==' },
                                { name: 'Pinterest', url: 'https://pinterest.com' },
                                { name: 'LinkedIn', url: 'https://www.linkedin.com/company/stinterior-studio/?viewAsMember=true' },
                                { name: 'Facebook', url: 'https://www.facebook.com/share/14o1GPzVu3o/?mibextid=wwXIfr' },

                            ].map((platform) => (
                                <a key={platform.name} href={platform.url} target="_blank" rel="noreferrer" style={{
                                    color: theme.textMain,
                                    textDecoration: 'none',
                                    fontSize: '0.95rem',
                                    fontWeight: '500',
                                    transition: 'color 0.2s ease'
                                }} onMouseEnter={(e) => e.target.style.color = theme.accent} onMouseLeave={(e) => e.target.style.color = theme.textMain}>
                                    {platform.name}
                                </a>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ContactUs;